(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("lodash"), require("@/staticAssets"), require("experiment"));
	else if(typeof define === 'function' && define.amd)
		define(["lodash", "@/staticAssets", "experiment"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("lodash"), require("@/staticAssets"), require("experiment")) : factory(root["lodash"], root["@/staticAssets"], root["experiment"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE__467__, __WEBPACK_EXTERNAL_MODULE__7812__, __WEBPACK_EXTERNAL_MODULE__5701__) => {
return 